<template>
  <v-card flat color="transparent" class="mt-n9">
    <v-row>
      <v-col cols="12">
        <v-radio-group
          multiple
          v-model="questionAnswer"
          :error-messages="errorMessage"
        >
          <v-checkbox
            v-for="opt in computedQuestionOpts"
            :key="opt.questionOptId"
            :label="opt.optLabel"
            :value="opt"
            v-model="questionAnswer"
            :error="errorMessage.length > 0"
            hide-details="auto"
            multiple
            @click="clickedOpt(opt)"
            :color="themeColor"
          >
            <template #label>
              <v-card flat>
                <v-row no-gutters :class="opt.etcOption ? '' : ''">
                  <v-col cols="12">
                    <v-img
                      v-if="opt.attachment"
                      class="mr-2"
                      max-width="100px"
                      max-height="200px"
                      contain
                      :src="opt.attachment.filePathUri"
                    ></v-img>
                    <span>{{ opt.optLabel }}</span>
                  </v-col>
                  <v-col cols="12" v-if="opt.etcOption">
                    <v-text-field
                      hide-details="auto"
                      dense
                      outlined
                      single-line
                      v-model="etcOptTextVal"
                      :disabled="!hasEtcOption"
                      :errorMessage="etcErrorMessage"
                      @click.prevent.stop="1==1"
                      :placeholder="$t('구체적인 내용을 입력해주세요.')"
                      :color="themeColor"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-card>
            </template>
          </v-checkbox>
        </v-radio-group>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { validate, extend } from "vee-validate";
import i18n from "@/redworks/plugins/i18n";
import _ from "lodash";
extend("select_count", {
  validate: (value, args) => {
    const length = value.length;
    if (null != args.min && null != args.max) {
      if (length >= args.min && length <= args.max) {
        return true;
      } else {
        return i18n.t("common.valid.select_between", args);
      }
    } else if (null != args.min) {
      if (length >= args.min) {
        return true;
      } else {
        return i18n.t("common.valid.select_min", args);
      }
    } else if (null != args.max) {
      if (length <= args.max) {
        return true;
      } else {
        return i18n.t("common.valid.select_max", args);
      }
    } else if (null != args.fix) {
      if (length == args.fix) {
        return true;
      } else {
        return i18n.t("common.valid.select_fix", args);
      }
    }
  },
  params: ["min", "max", "fix"],
});
export default {
  props: {
    question: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
    },
    isValid: {
      type: Boolean,
      default: false,
    },
    themeColor: {
      type: String,
      default: "primary",
    },
    responseAnswer: Object,
  },
  computed: {
    computedQuestionOpts(){
      return _.orderBy(
        this.question.questionOpts || [],
        [
          (opt) => opt.noneOfAbove,
          (opt) => opt.etcOption,
          "optSortNo"],
        ["asc","asc","asc"]
      );
    },
    questionAnswers() {
      let qa = null;
      let etcOptId = null;
      let etcOptVal = null;

      if (Array.isArray(this.questionAnswer)) {
        qa = this.questionAnswer.map((q) => {
          return q.questionOptId;
        });
        this.questionAnswer.forEach((q) => {
          if (q.etcOption) {
            etcOptId = q.questionOptId;
            etcOptVal = this.etcOptTextVal;
          }
        });
      } else {
        qa = [];
      }

      return {
        questionId: this.question.questionId,
        questionMatrixId: null,
        questionAnswerVals: qa,
        questionType: this.question.questionType,
        etcOptId: etcOptId,
        etcOptVal: etcOptVal,
      };
    },
    hasEtcOption() {
      return Array.isArray(this.questionAnswer)
        ? this.questionAnswer.some((qa) => qa.etcOption)
        : false;
    },
  },
  data() {
    return {
      questionAnswer: null,
      validationOptions: JSON.parse(this.question.validationOptions),
      errorMessage: [],
      etcErrorMessage: [],
      etcOptTextVal: null,
      skipInitialValidation: true,
    };
  },
  methods: {
    async checkValidation() {
      let rules = {};
      if (this.question.required) {
        rules["required"] = true;
      }

      if (this.hasEtcOption && !this.etcOptTextVal) {
        this.$emit("update:isValid", false);
        this.etcErrorMessage = this.$t("기타 옵션 내용을 입력하세요.");
        return;
      } else {
        this.$emit("update:isValid", true);
      }

      if (this.validationOptions) {
        switch (this.validationOptions.validType) {
          case "LIMIT_MIN_CNT":
            rules["select_count"] = { min: this.validationOptions.limitCount };
            break;
          case "LIMIT_MAX_CNT":
            rules["select_count"] = { max: this.validationOptions.limitCount };
            break;
          case "LIMIT_FIX_CNT":
            rules["select_count"] = { fix: this.validationOptions.limitCount };
            break;
          default:
            break;
        }
      }
      let rst = await validate(this.questionAnswer, rules, { name: "이 " });
      this.$emit("update:isValid", rst.valid);
      this.errorMessage = rst.errors;
    },
    clickedOpt(opt) {
      // 클릭 한 옵션에 따라 체크선택 옵션 제어
      // 해당 사항 이외의 옵션인 경우 해당 사항 없음 옵션 해제
      if (opt.noneOfAbove) {
        // 해당사항 없음을 선택 한 경우 다른 옵션 해제
        this.questionAnswer = this.questionAnswer.filter(
          (qa) => qa.questionOptId == opt.questionOptId
        );
      } else {
        this.questionAnswer = this.questionAnswer.filter(
          (qa) => !qa.noneOfAbove
        );
      }
    },
    setQuestionAnswer() {
      // 선택값 세팅
      let questionOptId = this.responseAnswer.response.map((r) => {
        return r.questionOptId;
      });
      const questionAnswer = this.question.questionOpts.filter((opt) => {
        return questionOptId.includes(opt.questionOptId);
      });

      // 최초 진입 시 답변이 없으면 초기 검증 패스
      this.skipInitialValidation = questionAnswer.length === 0;
      this.questionAnswer = questionAnswer;

      // 선택값이 기타인 경우 기타 입력값 세팅
      let etcOption = this.responseAnswer.response.filter(res => {
        return res.etcOption;
      })
      this.etcOptTextVal = etcOption.length > 0 ? etcOption[0].answerVal : null;
    },
  },
  watch: {
    async questionAnswer() {
      if (this.skipInitialValidation) {
        this.skipInitialValidation = false;
        return;
      }
      // // TODO 헤당 없음을 선택 하는 경우 해당 데이터 이외의 값을 모두 클리어.
      // if(this.questionAnswer.some(qa => qa.noneOfAbove)) {
      //   alert('클리어하자!')
      // }
      await this.checkValidation();
      this.$emit("input", this.questionAnswers);
    },
    async etcOptTextVal() {
      await this.checkValidation();
      this.$emit("input", this.questionAnswers);
    },
  },
  mounted() {
    if (this.responseAnswer) {
      this.setQuestionAnswer();
    }
    this.$emit("input", this.questionAnswers);
  },
};
</script>

<style></style>
